import React, { useRef, useState } from 'react';
import logo from './img/logo1.png';
import { trackEvent } from './analytics';

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const toggle = useRef(null);
  return (
    <header className="site-header" onKeyDown={event => {
      if (event.key === 'Escape') { setOpen(false); toggle.current.focus(); }
    }}>
      <div className="site-header-inner">
        <a href="/#start" className="site-brand" aria-label="현장통 홈"><img src={logo} width="36" height="36" alt="" /><span>현장통</span></a>
        <button className="site-menu-toggle" ref={toggle} type="button" aria-expanded={open} aria-controls="site-navigation" onClick={() => setOpen(!open)}>{open ? '메뉴 닫기' : '메뉴 열기'}<span aria-hidden="true">{open ? '×' : '☰'}</span></button>
        <nav id="site-navigation" className={`site-navigation${open ? ' is-open' : ''}`} aria-label="주 메뉴" onClick={event => { if (event.target.closest('a')) setOpen(false); }}>
          <a href="/#functions">주요 기능</a>
          <a href="/#proof">도입 근거</a>
          <a href="/blog">현장 실무 TIP</a>
          <a href="/#resources">자료실</a>
          <a href="/#contact" onClick={() => trackEvent('trial_cta_click', { location: 'header', page: window.location.pathname })}>체험 · 문의</a>
          <div className="site-service-links">
            <a href="https://www.tongpeoples.com/" target="_blank" rel="noreferrer">PC 서비스 <span aria-hidden="true">↗</span></a>
            <a href="/#downloads">앱 다운로드 <span aria-hidden="true">↓</span></a>
          </div>
        </nav>
      </div>
    </header>
  );
}
